import { logger } from 'helpers'
var apikeys = {}
try {
  // eslint-disable-next-line
  apikeys = require('../projects/' + process.env.REACT_APP_PROJECT + '/config/apikeys')
} catch (e) {
  logger.debug('No project-specific config for apikeys')
}

module.exports = {
  ...apikeys,
  gmaps: {
    v: '3.exp',
    key: 'AIzaSyB5WU09nFUkLgmPbogiG0K1O495DhlPNWQ'
  }
}



// WEBPACK FOOTER //
// ./src/config/apikeys.js